import Skeleton from '@/components/skeleton';

function TableResultSkeleton() {
  return (
    <>
      <section className="flex items-center justify-between">
        <Skeleton className="h-[18px] w-[205px] rounded-lg" />
        <Skeleton className="h-[40px] w-[153px] rounded-lg" />
      </section>
      <section className="mt-[10px] h-[301px] overflow-hidden rounded-lg border border-solid border-[#E4E6EB]">
        <div className="flex flex-col gap-5 border-b border-solid border-[#E4E6EB] p-5">
          <Skeleton className="h-[18px] w-full rounded-lg" />
          <Skeleton className="h-[18px] w-full rounded-lg" />
          <Skeleton className="h-[18px] w-[408px] max-w-full rounded-lg" />
        </div>
      </section>
    </>
  );
}

export default TableResultSkeleton;
